<template lang='pug'>
  div
    transition(name="slide-right", mode="out-in")
      router-view(:key="$route.fullPath")
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Home',

  props: {
    gestationInteractionId: {
      type: String
    }
  },

  computed: {
    ...mapGetters(['ultraFetal/study'])
  },

  data () {
    return {
    }
  },

  mounted () {
    this.fetchData()
  },

  beforeDestroy () {
    this.$store.dispatch('ultraFetal/unsubscribe', 'GestationInteraction')
    this.$store.dispatch('ultraFetal/unsubscribe', 'GestationInteractions')
    this.$store.dispatch('ultraFetal/unsubscribe', 'Gestation')
  },

  methods: {
    fetchData () {
      if (this.gestationInteractionId) {
        this.$store.dispatch('ultraFetal/getGestationInteraction', this.gestationInteractionId).then(data => {
          // Load Dicom params
          if (data.studyDate) {
            this.$store.dispatch('ultraFetal/getDicomParams', { patId: data.patient.patId, date: data.date, studyDate: data.studyDate })
          } else {
            this.$store.dispatch('ultraFetal/getDicomParams', { patId: data.patient.patId, date: data.date })
          }
          this.$store.dispatch('ultraFetal/getDicomParams', { patId: data.patient.patId, date: data.date })
          this.$store.dispatch('ultraFetal/getGestationInteractions', data.gestation.id)
          this.$store.dispatch('ultraFetal/getGestation', data.gestation.id).then(dataGestation => {
            if (this.$route.name === 'Ultra Fetal Gestation Interaction') {
              this.$router.push({name: 'Ultra Fetal Form', params: { formId: 'gestationalAge' }})
            }
          })
        })
      }
    }
  }
}
</script>

<style>
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.35s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}
</style>



// WEBPACK FOOTER //
// src/pages/ultra-fetal/Home.vue